module.exports = __webpack_public_path__ + "media/images/page/service_logo-gait-68b568dcba41a3b1c857a8900e635d72.png";